<template>
    <a-dropdown placement="bottomRight">
        <a-icon type="global" class="icon__lang" />
        <template>
            <a-menu
                :class="['menu', 'ant-pro-header-menu']"
                :selectedKeys="[lang]"
                @click="onchange"
            >
                <a-menu-item :key="locale" v-for="locale in locales">
                    {{ labels[locale] }}
                </a-menu-item>
            </a-menu>
        </template>
    </a-dropdown>
</template>

<script>
// eslint-disable-next-line no-unused-vars
const locales = ['zh-CN', 'en-US'];
const labels = {
    'zh-CN': '简体中文',
    'en-US': 'English'
};
// eslint-disable-next-line
const icons = {
    'zh-CN': '🇨🇳',
    'en-US': '🇺🇸'
};

export default {
    name: 'lang-selector',
    data() {
        return {
            icons,
            labels,
            locales
        };
    },
    computed: {
        lang() {
            return this.$store.state.lang;
        }
    },
    methods: {
        onchange({ key }) {
            console.log(key,'key');
            this.$store.dispatch('setLang', key, { root: true });
        }
    }
};
</script>
<style lang="less" scoped>
@import (reference) '~@/assets/styles/variables.less';

.flag[role='img'] {
    margin-right: 8px;
}
.icon__lang {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    color: @headerIconColor;
    font-size: 20px;
    cursor: pointer;
}
.ant-dropdown-open,
.icon__lang:hover {
    color: @primary-hover;
}
/deep/ .ant-dropdown-menu-item-selected{
background-color: rgba(40, 120, 232, .1);
}
</style>
